import * as React from 'react';
import { Control } from 'react-hook-form';
import { Controller } from 'react-hook-form';
import Check from 'svg/Check';
import classNames from 'styles/utils/classNames';

type Props = {
  control: Control<any>;
  name: string;
  label: string;
  labelClassName?: string;
  checkBoxClass?: string;
  textClass?: string;
  invert?: boolean;
  fillBrand?: boolean;
};

const CheckboxType = ({
  name,
  label,
  control,
  labelClassName = 'mb-2 flex items-center',
  checkBoxClass = 'h-5 w-5',
  textClass = '',
  invert = false,
  fillBrand = false,
}: Props) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, name, value } }) => (
        <label htmlFor={name} className={labelClassName}>
          <input
            id={name}
            value={value}
            type="checkbox"
            checked={value}
            name={name}
            onChange={() => onChange(!value)}
            className={classNames(
              'mr-2 cursor-pointer rounded focus:outline-none focus:ring-2 focus:ring-offset-2',
              // Base styling that applies to both modes
              'border-color-border-input-lightmode focus:ring-color-text-lightmode-primary focus:ring-offset-color-bg-lightmode-primary dark:border-color-border-input-darkmode dark:focus:ring-color-text-darkmode-primary dark:focus:ring-offset-color-bg-darkmode-primary',
              // Conditional styling based on invert
              invert
                ? 'peer sr-only'
                : 'text-color-bg-lightmode-invert dark:text-color-bg-darkmode-invert',
              checkBoxClass,
            )}
          />

          {/* Custom checkbox div only renders when invert is true as it is difficult to style the checkbox with the input */}
          {invert && (
            <div
              className={classNames(
                'mr-2 flex h-5 w-5 cursor-pointer items-center justify-center rounded',
                value
                  ? fillBrand
                    ? 'bg-color-bg-darkmode-brand'
                    : 'bg-color-bg-darkmode-invert'
                  : fillBrand
                  ? 'border border-color-border-hover-darkmode dark:border-color-border-hover-lightmode'
                  : 'border border-color-border-input-lightmode',
              )}
            >
              <Check
                className={classNames(
                  'h-4 w-4 ',
                  value ? 'opacity-100' : 'opacity-0',
                  fillBrand
                    ? 'text-color-text-lightmode-primary'
                    : 'text-color-text-darkmode-invert',
                )}
              />
            </div>
          )}

          <span
            className={classNames(
              'typography-product-body ',
              textClass,
              invert
                ? 'text-color-text-lightmode-invert dark:text-color-text-darkmode-invert'
                : 'text-color-text-lightmode-secondary dark:text-color-text-darkmode-secondary',
            )}
          >
            {label}
          </span>
        </label>
      )}
    />
  );
};

export default CheckboxType;
